import { render } from "./Dispatched.vue?vue&type=template&id=376b38e8"
import script from "./Dispatched.vue?vue&type=script&lang=js"
export * from "./Dispatched.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__